import type { Meta, StoryObj } from '@storybook/angular';
import { expect, within } from 'storybook/test';
import { SadWineglassIconComponent } from '../../app/content/layout/components/general/sad-wineglass-icon/sad-wineglass-icon.component';

const meta: Meta<SadWineglassIconComponent> = {
  title: 'Atoms/Sad Wineglass Icon',
  component: SadWineglassIconComponent,
  parameters: {
    layout: 'centered',
    docs: {
      description: {
        component: 'Empty state illustration with a sad wineglass. Used for 404 pages, empty search results, and error states.',
      },
    },
  },
  argTypes: {
    text: { control: 'text', description: 'Message text displayed below the icon' },
    buttonText: { control: 'text', description: 'Text for the action button' },
    blackWineglass: { control: 'boolean', description: 'Use black variant of the icon' },
    width: { control: { type: 'number', min: 50, max: 400 }, description: 'Icon width in px' },
    height: { control: { type: 'number', min: 50, max: 400 }, description: 'Icon height in px' },
    buttonClick: { action: 'buttonClick' },
  },
};

export default meta;
type Story = StoryObj<SadWineglassIconComponent>;

export const Default: Story = {
  args: {
    text: 'Vi fandt desværre ingen resultater',
    buttonText: 'Gå til forsiden',
    width: 200,
    height: 200,
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/vi fandt desværre/i)).toBeInTheDocument();
  },
};

export const NotFound: Story = {
  args: {
    text: 'Siden blev ikke fundet (404)',
    buttonText: 'Tilbage til forsiden',
    width: 200,
    height: 200,
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/404/)).toBeInTheDocument();
  },
};

export const EmptySearch: Story = {
  args: {
    text: 'Din søgning gav ingen resultater. Prøv et andet søgeord.',
    buttonText: 'Nulstil søgning',
    width: 150,
    height: 150,
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/din søgning/i)).toBeInTheDocument();
  },
};

export const BlackVariant: Story = {
  args: {
    text: 'Noget gik galt',
    buttonText: 'Prøv igen',
    blackWineglass: true,
    width: 200,
    height: 200,
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/noget gik galt/i)).toBeInTheDocument();
  },
};

export const SmallSize: Story = {
  args: {
    text: 'Ingen data',
    width: 80,
    height: 80,
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/ingen data/i)).toBeInTheDocument();
  },
};

export const NoButton: Story = {
  args: {
    text: 'Din indkøbskurv er tom',
    width: 200,
    height: 200,
  },
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/indkøbskurv er tom/i)).toBeInTheDocument();
  },
};
